import apiV2 from '../api/v2';
import { resolveViewerTimeZone, type EventDto } from '@odo/shared-ui';

// Types mirror backend/src/routes/api/v2/events/*.service.ts exactly
// (spec §7). `zoomUrl` is deliberately absent from `EventDto` and only
// ever returned by the join endpoint, after server-side validation.

export interface EventJoinUrl {
    readonly url: string;
}

export interface EventSignUpResult {
    readonly message: string;
}

export async function fetchActiveEvents(): Promise<EventDto[]> {
    const response = await apiV2.get<EventDto[]>('/events/active');
    return response.data;
}

/**
 * The browser's IANA zone rides along with the RSVP. The confirmation email is
 * rendered server-side, where there is no browser to ask, so without this it
 * could only state one canonical zone while the banner the practitioner just
 * clicked states theirs.
 */
export async function signUpForEvent(eventId: string): Promise<EventSignUpResult> {
    const response = await apiV2.post<EventSignUpResult>(`/events/${eventId}/sign-up`, {
        timeZone: resolveViewerTimeZone()
    });
    return response.data;
}

export async function fetchEventJoinUrl(eventId: string): Promise<EventJoinUrl> {
    const response = await apiV2.get<EventJoinUrl>(`/events/${eventId}/join`);
    return response.data;
}
